import React from "react";

import { withFilterSectionBox } from "./withFilterSectionBox";

import { MultiBox } from "@bared/ui";

export const FilterSectionBox = withFilterSectionBox(
  ({ handleChange, layout, options, className }) => {
    return (
      <MultiBox
        options={options}
        handleChange={handleChange}
        layout={layout}
        className={className}
      />
    );
  },
);
